import { ITEM_TYPES } from 'Utils/index';

export class ContinueWatchingItem {
    constructor(item) {
        item.getId = () => (item.data.type === 'PVR' ? item.data.scheduleId : item.data.id);
        item.data.scheduleId = item.getId();
        item.getImageUrl = () => item.data.imageUrl;
        item.getProgressPercent = () => item.data.completedInPercentage;
        item.originalModelType = ITEM_TYPES.VOD;
        if (item.data.type === 'PVR') {
            item.originalModelType = ITEM_TYPES.RECORDING;
        } else if (item.data.type === 'ARCHIVE') {
            item.originalModelType = ITEM_TYPES.TV;
        }
        item.modelType = ITEM_TYPES.CONTINUE_WATCHING;

        // eslint-disable-next-line no-constructor-return
        return item;
    }
}
